import React from "react";
import { motion } from "framer-motion";
import { EDUCATION } from "../../data/content";

const Item = ({ edu, index }) => {
    return (
        <motion.div
            data-testid={`education-item-${edu.id}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{
                duration: 0.7,
                delay: index * 0.08,
                ease: [0.22, 1, 0.36, 1],
            }}
            className="border-t-2 border-[var(--ink)] py-8 md:py-10 px-1 md:px-2"
        >
            <div className="grid grid-cols-12 gap-x-3 gap-y-4 md:gap-6 items-start">
                {/* index */}
                <div className="col-span-2 md:col-span-1 mono-meta md:pt-2">
                    0{index + 1}
                </div>

                {/* school + degree */}
                <div className="col-span-10 md:col-span-7">
                    <h3 className="font-serif tracking-[-0.02em] leading-[0.98] text-[clamp(1.7rem,4.2vw,3.25rem)]">
                        {edu.school}
                    </h3>
                    <p className="mt-3 font-serif italic text-lg md:text-2xl text-[var(--ink)] leading-snug">
                        {edu.degree}
                    </p>
                    <div className="mt-2 mono-label !text-[10px] text-[var(--ink-soft)]">
                        {edu.detail}
                    </div>
                </div>

                {/* meta + result */}
                <div className="col-span-12 md:col-span-4 md:pt-2 flex flex-row md:flex-col flex-wrap items-baseline md:items-start gap-x-8 gap-y-3">
                    <div>
                        <div className="mono-label !text-[10px] text-[var(--ink-soft)]">
                            Years
                        </div>
                        <div className="mono-meta mt-1">{edu.period}</div>
                    </div>
                    <div>
                        <div className="mono-label !text-[10px] text-[var(--ink-soft)]">
                            Location
                        </div>
                        <div className="mono-meta mt-1">{edu.location}</div>
                    </div>
                    <div className="md:mt-2">
                        <span className="inline-flex items-center gap-2 border-2 border-[var(--ink)] px-3 py-1.5 hard-shadow-sm bg-[var(--surface)]">
                            <span className="w-1.5 h-1.5 bg-[var(--brand)]" />
                            <span className="mono-label !text-[11px]">
                                {edu.result}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export const Education = () => {
    return (
        <section
            id="education"
            data-testid="education-section"
            className="relative pt-24 md:pt-32 pb-16 md:pb-24"
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="grid grid-cols-12 gap-4 md:gap-6 pb-10 md:pb-14"
                >
                    <div className="col-span-12 md:col-span-8">
                        <div className="mono-label mb-4 flex items-center gap-2">
                            <span className="inline-block w-2.5 h-2.5 bg-[var(--brand)]" />
                            Ch. 04 — Foundation
                        </div>
                        <h2 className="font-serif text-[clamp(2.2rem,5.5vw,4.25rem)] leading-[0.95] tracking-[-0.02em]">
                            Where I Learned
                            <br />
                            <span className="italic text-[var(--ink-soft)]">
                                to Build.
                            </span>
                        </h2>
                    </div>
                </motion.div>

                <div className="border-b-2 border-[var(--ink)]">
                    {EDUCATION.map((edu, i) => (
                        <Item key={edu.id} edu={edu} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
};
